import React from "react";
import "./Sidebar.css";
import { updateLocalStorage } from "../../Pages/CreateNewBot/AppDrawerNav";
const SideBar = ({
  type,
  open_sidebar,
  set_open_sidebar,
  selectedKey,
  sidebarRef,
}) => {
  const metadataFilteringInfo =
    "Metadata such as tags or fields can be associated with documents when they are indexed in a vector database. For example, a document could have metadata like {'field': 'LLM development'} {'field': 'Business'}.";
  const apikey = selectedKey || "";
  const cmd = `curl -X POST https://app.queryloop.com/api/developer/use -H "Content-Type: application/json" -H "Authorization: SecretKey ${apikey}" -d "{\"query\": \"What is this about?\"}"`;

  const handle_close_sidebar = () => {
    set_open_sidebar(false);
    setTimeout(() => {
      updateLocalStorage("open_sidebar", "false");
      updateLocalStorage("type", "");
    }, 100);
  };

  return (
    <div className={`side-bar ${open_sidebar ? "open" : ""}`} ref={sidebarRef}>
      <div className="side-bar_contents">
        <button
          id="btn-close-sidebar"
          className="close-btn"
          onClick={handle_close_sidebar}
        >
          X
        </button>
        {type === "retrieval_hyperparameters" && (
          <div className="side-bar_contents_info top-k">
            <h1>Retrieval Hyperparameters</h1>
            <p>
              Retrieval Node is a crucial element in information retrieval
              systems that processes queries to extract relevant documents from
              a corpus through several key steps. These include chunking
              documents into manageable sizes, using various metrics to measure
              similarity between queries and documents, and selecting
              appropriate retrieval methods based on query complexity. The
              process also involves reranking retrieved documents for better
              relevance, limiting results to a specified number, and utilizing
              embedding models to convert text into numerical vectors for
              semantic analysis. Additionally, it addresses data upload
              considerations, confidentiality levels, and the importance of
              balancing detail with context to optimize retrieval effectiveness.
              Understanding these components enables the design of tailored
              retrieval nodes for specific information retrieval needs.
            </p>
          </div>
        )}
        {type === "input_nodes" && (
          <div className="side-bar_contents_info top-k">
            <h1>Inputs</h1>
            <br />
            <p>
              <span>Advanced options:</span>
            </p>
            <p>
              <span></span>These advanced options allow you to customize how the
              LLM generates responses, ensuring they align with your specific
              requirements regarding tone, content handling, and interaction
              style.
            </p>
            <br />
            <p>
              <span></span>Block Certain Content:
            </p>
            <p>
              <span>Description: </span>This setting manages sensitive or
              inappropriate content by blocking specific types of language, such
              as culturally insensitive terms, biases, or discriminatory
              language. It helps ensure that the generated content adheres to
              ethical standards and user-specific guidelines, such as avoiding
              hate speech.
            </p>
            <p>
              <span>Use Case:</span> Enable this to ensure that content
              generated aligns with responsible and respectful communication
              standards.
            </p>
            <br />
            <p>
              <span></span>Source citation:
            </p>
            <p>
              <span>Description:</span> Determines whether the LLM should
              include citations or references in its responses. Enabling this
              option ensures that answers are backed by sources, adding
              credibility and reliability to the output.
            </p>
            <p>
              <span>Use Case:</span> Select Yes if you need responses that
              include evidence or references to enhance trust, especially for
              academic, research, or fact-based queries.
            </p>
            <br />
            <p>
              <span></span>Response Tone:
            </p>
            <p>
              <span>Description:</span> The tone of the LLM’s responses is
              influenced by your selection of formal, informal, or no
              preference. Choosing the response tone guides the model on how to
              phrase its answers, aligning with your desired style.
            </p>
            <p>
              <span>Use Case: </span>Select Formal for professional or academic
              interactions, Informal for casual conversations, and No Preference
              if you are flexible with the tone.
            </p>
            <br />
            <p>
              <span></span>Follow-Up Questions:
            </p>
            <p>
              <span>Description:</span> This option enables the memory feature
              in the application, allowing the LLM to retain context across
              interactions. It lets users ask clarifying or follow-up questions,
              creating a more interactive and continuous conversation flow.
            </p>
            <p>
              <span>Use Case:</span> Enable this when you want the ability to
              delve deeper into topics, refine answers, or engage in multi-turn
              dialogues for more complex queries.
            </p>
            <br />
            <p>
              <span></span>These options empower you to tailor the behavior and
              output of the LLM, enhancing the relevance, quality, and
              appropriateness of the generated responses based on your specific
              needs.
            </p>
          </div>
        )}
        {type === "chunk_size" && (
          <div className="side-bar_contents_info chunk">
            <h1>Chunk Size</h1>
            <p>
              Chunking is the process of breaking long pieces of text into
              smaller segments, known as chunks. This technique helps in
              managing and retrieving information more effectively, especially
              when dealing with lengthy or complex documents. The chunk size
              refers to the length of these text segments, and selecting the
              appropriate size can significantly impact the balance between
              capturing detailed information and maintaining overall context.
            </p>
            <br />
            <p>
              <span style={{ fontSize: "1.0rem" }}>How Chunking Works?</span>
            </p>
            <p>
              We use a recursive character text splitter that prioritizes
              breaking the text at the paragraph level. If breaking at the
              paragraph level is not possible, it moves to sentences, and if
              that also isn't feasible, it breaks at the word level.
            </p>

            <p>
              <span>Tiny (300 characters):</span>Best for capturing highly
              detailed information with minimal context. Ideal for short queries
              or when precise, fine-grained data extraction is required.
            </p>
            <p>
              <span>Small (700 characters):</span>Provides a balance between
              detail and context, suitable for moderately detailed retrieval
              where fine details matter but broader context is also needed.
            </p>
            <p>
              <span>Medium (1800 characters):</span>Offers a broader view of the
              text while maintaining some detail. Great for handling longer
              sections where maintaining some context without overwhelming
              details is necessary.
            </p>
            <p>
              <span>Large (4200 characters):</span>Captures broader sections of
              the document, maintaining the most context. Useful for longer or
              shorter documents that can fit in one chunk, helping to avoid the
              potential context loss from chunking.
            </p>
            <br />
            <p>
              <span style={{ fontSize: "1.0rem" }}>
                Choosing the Right Chunk Size
              </span>
            </p>
            <p>
              <span>Smaller Chunks (Tiny, Small):</span>Capture detailed
              insights but may lose broader context. Ideal for precise
              extractions or when dealing with data that requires granular
              analysis.
            </p>
            <p>
              <span>Larger Chunks (Medium, Large):</span>Maintain broader
              context but might miss very fine details. Best for longer,
              continuous documents or when preserving the overall narrative is
              crucial.
            </p>
            <br />
            <h3 style={{ color: "var(--colorPrimaryHover)" }}>
              Choosing the correct chunk size depends on the document type,
              retrieval needs, and the importance of detail versus context. For
              shorter documents, opting for larger chunks can help keep the
              document intact, avoiding unnecessary splitting and context loss.
            </h3>
          </div>
        )}
        {type === "metrics_type" && (
          <div className="side-bar_contents_info">
            <h1>Metric</h1>
            <p>
              Choosing the right metric type is crucial for optimizing
              information retrieval based on your data and query needs. Here's
              an explanation of each metric type, including their strengths and
              limitations, to help you decide which is best suited for your
              application:
            </p>
            <br />
            <p>
              <span style={{ fontSize: "1.0rem" }}>Cosine Similarity:</span>
            </p>
            <p>
              <span>What It Does: </span>Measures the angle between two vectors,
              focusing on the direction rather than their magnitude. It
              essentially tells how similar two pieces of text are, regardless
              of their length.
            </p>
            <p>
              <span>Best For: </span>Comparing the semantic meaning of short
              texts, sentences, or queries where direction matters more than
              word count. Ideal for applications like document classification,
              clustering, and detecting similarities in content with varying
              lengths.
            </p>
            <p>
              <span>Advantages: </span>Robust to the size of the text, meaning
              longer or shorter texts can be compared without bias towards
              length.
            </p>
            <p>
              <span>Disadvantages: </span>Not sensitive to the absolute scale or
              length of the vectors, which means it might miss finer differences
              in content magnitude or emphasis.
            </p>
            <br />
            <p>
              <span style={{ fontSize: "1.0rem" }}>Euclidean Distance:</span>
            </p>
            <p>
              <span>What It Does: </span>Measures the straight-line distance
              between two vectors in a multidimensional space, accounting for
              both magnitude and direction.
            </p>
            <p>
              <span>Best For:</span> Use when exact numerical differences
              matter, such as in recommendation systems where the precise
              distance reflects the degree of dissimilarity between user
              preferences.
            </p>
            <p>
              <span>Advantages:</span> Captures differences in magnitude and can
              be useful when exact positional differences between vectors are
              significant.
            </p>
            <p>
              <span>Disadvantages:</span> Sensitive to vector length, meaning it
              may be biased towards longer texts or documents unless normalized.
            </p>
            <br />
            <p>
              <span style={{ fontSize: "1.0rem" }}>Dot Product:</span>
            </p>
            <p>
              <span>What It Does: </span>Calculates the alignment between
              vectors by multiplying corresponding elements and summing them up,
              combining both direction and magnitude information.
            </p>
            <p>
              <span>Best For: </span> Applications in neural networks and
              scenarios where magnitude and direction together define the level
              of similarity.
            </p>
            <p>
              <span>Advantages: </span>Efficient and directly measures
              similarity, capturing both intensity and alignment of vectors.
            </p>
            <p>
              <span>Disadvantages: </span>Can be biased towards longer vectors
              and does not account for scaling differences between vectors
              unless adjusted.
            </p>
            <br />
            <p>
              <span style={{ fontSize: "1.0rem" }}>
                Hybrid (Dense + Sparse Embeddings):
              </span>
            </p>
            <p>
              <span>What It Does:</span> Merges dense embeddings (like those
              generated by neural networks) with sparse embeddings (such as
              BM25, a traditional information retrieval algorithm that uses term
              frequency and inverse document frequency). This combination
              leverages the strengths of both dense, context-aware models and
              sparse, keyword-focused models.
            </p>
            <p>
              <span>Best For: </span>Scenarios where you need a balance between
              deep semantic understanding and precise keyword matching. Ideal
              for mixed-content data where both nuanced meaning and exact term
              presence are critical.
            </p>
            <p>
              <span style={{ marginTop: "1px" }}>Advantages: </span>
            </p>
            <blockquote>
              <p>
                <span>Dense Embeddings:</span> Capture complex semantic
                relationships, making them great for understanding context,
                synonyms, and nuanced meanings.
              </p>
              <p>
                <span>Sparse Embeddings (BM25):</span> Excel in precise term
                matching, particularly useful when exact keyword presence is
                vital (e.g., legal documents or technical queries).
              </p>
              <p>
                <span>Hybrid Strength:</span> Offers a robust, balanced
                retrieval approach that handles both deep semantic connections
                and exact term matches.
              </p>
            </blockquote>
            <p>
              <span style={{ marginTop: "1px" }}>Disadvantages: </span>
            </p>
            <blockquote>
              <p>
                <span>
                  Hybrid models can be computationally heavier due to the
                  integration of both dense and sparse computations.
                </span>
              </p>
              <p>
                <span>
                  May require tuning to balance the contribution of dense vs.
                  sparse components based on the nature of the data and queries.
                </span>
              </p>
            </blockquote>
            <br />
            <p>
              <span style={{ fontSize: "1.0rem" }}>
                Selecting the Right Metric Based on Your Data and Queries:
              </span>
            </p>
            <p>
              <span>
                For Short, Context-Heavy Queries (e.g., searching conversational
                or narrative texts):
              </span>
            </p>
            <p>Cosine Similarity is typically sufficient and performs well.</p>
            <br />
            <p>
              <span>
                For Length-Sensitive Data (e.g., comparing reviews or
                recommendations where length variations carry meaning):
              </span>
            </p>
            <p>Euclidean Distance might better capture differences.</p>
            <br />
            <p>
              <span>
                For Tasks Involving Neural Models or Importance of Alignment:
              </span>
            </p>
            <p>Use the Dot Product to efficiently compare relevance.</p>
            <br />
            <p>
              <span>
                For Diverse Content with Need for Both Semantic Understanding
                and Keyword Matching:
              </span>
            </p>
            <p>
              The Hybrid approach will provide the most comprehensive retrieval,
              particularly when exact keywords and contextual meaning are both
              critical.
            </p>
          </div>
        )}
        {type === "post_retrieval" && (
          <div className="side-bar_contents_info post-retrieval">
            <h1>Reranker</h1>
            <p>
              Rerankers refine the initial search results by reordering them to
              improve their relevance and quality based on specific criteria.
              Selecting the right reranking method can significantly enhance the
              overall retrieval performance, ensuring that the most useful
              information is presented first. Here’s a breakdown of each
              reranking method, including their strengths and the best scenarios
              for their use:
            </p>
            <p>
              <span style={{ fontSize: "1.0rem" }}>No reranker:</span>
            </p>
            <p>
              <span>What It Does:</span> Focuses solely on retrieving the most
              relevant results based on the initial query without any additional
              post-processing or reordering.
            </p>
            <p>
              <span>Best For:</span> Simple use cases where the initial search
              quality is sufficient, and you need the most straightforward and
              computationally efficient reranking approach.
            </p>
            <p>
              <span>Advantages: </span>Fast and efficient since it involves
              minimal processing beyond the initial retrieval. It’s
              straightforward and reliable for direct, relevance-focused tasks.
            </p>
            <p>
              <span>Disadvantages:</span> Does not consider diversity or deeper
              contextual alignment, which can result in repetitive or narrowly
              focused results.
            </p>
            <br />

            <p>
              <span style={{ fontSize: "1.0rem" }}>
                Maximal Marginal Relevance (MMR):
              </span>
            </p>
            <p>
              <span>What It Does:</span> Balances relevance and diversity by
              iteratively selecting results that are both highly relevant to the
              query and distinct from previously selected items. This approach
              helps to ensure a varied set of results, reducing redundancy.
            </p>
            <p>
              <span>Best For:</span> Use in scenarios where you need a balanced
              set of results that capture different aspects of a query, such as
              when dealing with news aggregation, content curation, or diverse
              information needs.
            </p>
            <p>
              <span>Advantages:</span> Prevents the retrieval of duplicates and
              overly similar results, offering a broader perspective on the
              query topic.
            </p>
            <p>
              <span>Disadvantages: </span>The balance between relevance and
              diversity can sometimes dilute the precision of the most directly
              relevant results if not carefully tuned.
            </p>
            <br />

            <p>
              <span style={{ fontSize: "1.0rem" }}>Cohere Rerank:</span>
            </p>
            <p>
              <span>What It Does: </span>WUtilizes a cross-encoder to jointly
              analyze and reorder search results based on coherence and
              contextual fit. Unlike traditional methods that assess queries and
              documents independently, cross-encoders evaluate the interaction
              between the two, offering a more integrated approach to relevance.
            </p>
            <p>
              <span>Best For: </span>Ideal for complex queries where context and
              detailed matching between the query and results are crucial, such
              as in academic search, customer support, or detailed content
              analysis.
            </p>
            <p>
              <span>Advantages:</span> Provides a deeper, joint understanding of
              query-document relevance, improving the quality of ranking through
              comprehensive analysis of both elements together.
            </p>
            <p>
              <span>Disadvantages:</span> Computationally intensive as it
              processes each query-result pair jointly, which may slow down the
              reranking for large datasets.
            </p>
            <br />

            <p>
              <span style={{ fontSize: "1.0rem" }}>LLM Rerank:</span>
            </p>
            <p>
              <span>What It Does:</span> Uses a large language model (LLM) to
              evaluate and reorder search results, enhancing the accuracy and
              relevance based on nuanced language understanding. The LLM can
              assess factors such as coherence, context, and semantic fit,
              making it highly adaptive to various types of queries.
            </p>
            <p>
              <span>Best For:</span> Situations where high-quality, contextually
              aware reranking is needed, such as in personalized search,
              advanced document retrieval, and contexts requiring deep semantic
              understanding.
            </p>
            <p>
              <span>Advantages:</span> Offers sophisticated reranking
              capabilities by leveraging advanced language models that can
              interpret complex relationships and contextual nuances.
            </p>
            <p>
              <span>Disadvantages:</span> Resource-intensive and can be slower
              than other reranking methods, especially with large volumes of
              data. Requires significant computational power and can be costly
              in deployment.
            </p>
            <br />

            <p>
              <span style={{ fontSize: "1.0rem" }}>
                Choosing the Right Reranker:
              </span>
            </p>

            <p>
              <span>
                For quick, straightforward tasks where relevance is the only
                priority: Choose None
              </span>
            </p>
            <p>
              <span>
                To maintain a diverse set of results that still align with the
                query: Opt for Maximal Marginal Relevance (MMR).
              </span>
            </p>
            <p>
              <span>
                When deep, context-rich alignment between query and results is
                critical: Use Cohere Rerank.
              </span>
            </p>
            <p>
              <span>
                For the most advanced, nuanced reranking with high accuracy and
                contextual fit: Go with LLM Rerank.
              </span>
            </p>
          </div>
        )}
        {type === "embedding_model" && (
          <div className="side-bar_contents_info embedding">
            <h1>Embedding Model</h1>
            <p>
              Embedding models are essential for transforming text into
              numerical vectors that capture the semantic meaning of the
              content. These vectors are then used in various retrieval,
              ranking, and classification tasks. Different embedding models
              offer varying levels of performance and specificity, and the
              choice of model can significantly impact retrieval effectiveness.
            </p>
            <br />
            <p>
              <span style={{ fontSize: "1.0rem" }}>
                text-embedding-ada-002:
              </span>
            </p>
            <p>
              <span>Description:</span> A highly efficient and versatile
              embedding model known for its balance between performance and
              computational cost. It captures general semantic information,
              making it suitable for a wide range of retrieval tasks.
            </p>
            <p>
              <span>Best For:</span> General-purpose searches, topic modeling,
              and classification tasks where high quality and speed are needed
              without significant resource demands.
            </p>
            <p>
              <span>Advantages:</span> Fast, accurate, and cost-effective;
              widely used for various natural language processing tasks.
            </p>
            <p>
              <span>Disadvantages:</span> May not capture domain-specific
              nuances as effectively as more specialized or fine-tuned models.
            </p>
            <br />

            <p>
              <span style={{ fontSize: "1.0rem" }}>
                text-embedding-3-small:
              </span>
            </p>

            <p>
              <span>Description:</span> A lightweight embedding model designed
              for low-latency environments or applications where speed is
              prioritized over deep semantic understanding.
            </p>
            <p>
              <span>Best For: </span>Scenarios requiring quick responses, like
              real-time applications or low-resource settings.
            </p>
            <p>
              <span>Advantages: </span>Extremely fast and resource-efficient,
              ideal for high-volume or low-latency tasks.
            </p>
            <p>
              <span>Disadvantages:</span> Limited in capturing complex or
              nuanced text relationships compared to larger models.
            </p>
            <br />

            <p>
              <span style={{ fontSize: "1.0rem" }}>
                text-embedding-3-large:
              </span>
            </p>

            <p>
              <span></span>Description: A more robust embedding model with
              increased capacity to understand complex language patterns and
              relationships.
            </p>
            <p>
              <span>Best For:</span> Advanced retrieval tasks, deep semantic
              analysis, and contexts where a high degree of text comprehension
              is required.
            </p>
            <p>
              <span>Advantages:</span> Offers deeper insight and captures
              complex language interactions, enhancing retrieval quality in
              intricate queries.
            </p>
            <p>
              <span>Disadvantages:</span> Slower and more resource-intensive,
              which might not be ideal for high-speed applications
            </p>
            <br />

            <p>
              <span style={{ fontSize: "1.0rem" }}>Fine-Tuned Model:</span>
            </p>

            <p>
              <span>Description:</span> This model is tailored specifically to
              your data by training on uploaded documents. The fine-tuning
              process enhances the model's ability to understand domain-specific
              language, concepts, and terminology.
            </p>
            <p>
              <span>Best For:</span> Highly specialized retrieval tasks where
              the general embedding models might miss context-specific nuances,
              such as industry-specific documents, legal texts, or technical
              manuals.
            </p>
            <p>
              <span>Advantages:</span>
            </p>
            <blockquote>
              <p>
                <span>Domain Adaptation: </span>Fine-tuning allows the model to
                better align with the language and context specific to your
                data, improving retrieval accuracy.
              </p>
              <p>
                <span>Automatic Training Data Generation:</span> The model
                leverages your uploaded documents to create training data
                automatically, streamlining the fine-tuning process without
                requiring manual data curation.
              </p>
            </blockquote>
            <p>
              <span>Disadvantages: </span>Requires additional training time and
              computational resources. Effectiveness depends on the quality and
              diversity of the training data provided.
            </p>

            <br />
            <p>
              <span style={{ fontSize: "1.0rem" }}>
                Choosing the Right Embedding Model:
              </span>
            </p>
            <p>
              <span></span>For general use with balanced speed and quality:
              Choose text-embedding-ada-002.
            </p>
            <p>
              <span></span>For quick, low-latency applications: Use
              text-embedding-3-small.
            </p>
            <p>
              <span></span>For in-depth analysis where understanding complex
              semantics is crucial: Opt for text-embedding-3-large.
            </p>
            <p>
              <span></span>For specialized contexts requiring high relevance and
              adaptation to specific terminology: Go with a Fine-Tuned Model,
              particularly if you have access to relevant training data.
            </p>

            <br />
            <h3 style={{ color: "var(--colorPrimaryHover)" }}>
              Embedding models play a critical role in information retrieval,
              and selecting the appropriate model can enhance the relevance and
              accuracy of the results, aligning closely with the unique needs of
              your data and queries.
            </h3>
          </div>
        )}
        {type === "retrieval_method" && (
          <div className="side-bar_contents_info retrieval-method">
            <h1>Retrieval Methods</h1>
            <p>
              Choosing the right retrieval method is essential to ensure that
              the search results align with your specific needs. Each method has
              distinct characteristics that make it suitable for different types
              of queries and data. Here's an explanation of each retrieval
              method, including their advantages and when to use them:
            </p>

            <p>
              <span style={{ fontSize: "1.0rem" }}>Basic: </span>
            </p>
            <p>
              <span>What it does: </span> Retrieves documents by finding the
              closest matches in a vector space using similarity metrics like
              Cosine Similarity.
            </p>
            <p>
              <span>Best For: </span>General searches where precise matching is
              needed without any special contextual requirements.
            </p>
            <p>
              <span>Advantages: </span>Simple and efficient; works well for
              straightforward queries and data.
            </p>
            <p>
              <span>Disadvantages: </span>Can miss context-specific details as
              it focuses purely on direct similarity without additional context.
              Not ideal for nuanced or complex information retrieval.
            </p>
            <br />

            <p>
              <span style={{ fontSize: "1.0rem" }}>Chunk Window:</span>
            </p>
            <p>
              <span>What It Does:</span>This method vectorizes individual chunks
              of text but keeps track of the preceding and following chunks.
              After retrieval, it appends these adjacent chunks to provide more
              context to the retrieved content.
            </p>
            <p>
              <span>Best For: </span>Situations where understanding the broader
              context of a text is important, such as in technical documents,
              articles, or long-form content.
            </p>
            <p>
              <span>Advantages: </span>Enhances comprehension by preserving the
              flow of information around the retrieved chunk, making responses
              more coherent.
            </p>
            <p>
              <span>Disadvantages: </span>Slightly increases computational load
              as it processes additional contextual chunks, which might not
              always be necessary for simpler queries.
            </p>
            <br />

            <p>
              <span style={{ fontSize: "1.0rem" }}>
                GraphRAG with Vector Data:
              </span>
            </p>
            <p>
              <span>What It Does:</span> Creates a knowledge graph from the
              given data. Any entities mentioned in the user's query are
              identified, and their neighbors are traversed in the knowledge
              graph to provide a holistic view of all relevant information in
              the documents related to the query.
            </p>
            <p>
              <span>Best For:</span> Summary-type questions and queries
              requiring an overall understanding of the relationships discussed.
              An additional vector search helps retrieve localized context to
              include specific details.
            </p>

            <p>
              <span>Disadvantages:</span> High document processing cost and
              slightly increased latency during querying.
            </p>
            <br />

            <p>
              <span style={{ fontSize: "1.0rem" }}>Contextual Retrieval:</span>
            </p>
            <p>
              <span>What It Does:</span> Enhances the retrieval process by
              appending additional context to each chunk of data, improving both
              the accuracy of retrieval and the quality of generated responses.
            </p>
            <p>
              <span>Best For:</span> Unstructured data that is prone to losing
              context due to chunking, ensuring the retrieval process maintains
              relevance and coherence.
            </p>
            <p>
              <span>Disadvantages:</span> High document processing costs, which
              can be a limiting factor for extensive datasets.
            </p>
            <br />

            <p>
              <span style={{ fontSize: "1.0rem" }}>
                Choosing the Right Retrieval Method:
              </span>
            </p>
            <p>
              <span>
                <strong>Basic:</strong> Ideal for straightforward searches where
                precision is required but additional context is not essential.
              </span>
            </p>
            <p>
              <span>
                <strong>Chunk Window:</strong> Best suited for scenarios where
                preserving contextual understanding is critical, such as
                analyzing long texts or sequential data.
              </span>
            </p>
            <p>
              <span>
                <strong>GraphRAG with Vector Data:</strong> Best for complex
                queries requiring a comprehensive understanding of relationships
                across data. By creating a knowledge graph from the data, this
                method identifies relevant entities and explores their neighbors
                in the graph to generate holistic, context-aware responses.
              </span>
            </p>
            <p>
              <span>
                <strong>Contextual Retrieval:</strong> Use when working with
                unstructured data that risks losing relevance due to chunking.
                This method appends additional context to ensure accurate
                retrieval and coherent responses.
              </span>
            </p>
          </div>
        )}
        {type === "query_transformations" && (
          <div className="side-bar_contents_info retrieval-method">
            <h1>Query Transformations</h1>
            <p>
              <p>
                Choosing the right query transformation method is critical to
                ensuring that your search results not only align with user
                queries but also address the nuances and complexities of the
                information retrieval process. Each transformation method offers
                unique capabilities, making them suitable for different types of
                questions and data requirements. Below, we outline the purpose,
                advantages, and best use cases for each method, helping you
                select the most effective approach for your needs:
              </p>
            </p>

            <p>
              <span style={{ fontSize: "1.0rem" }}>None:</span>
            </p>
            <p>
              <strong>What it does:</strong> No query transformations will be
              applied. The original query intent is preserved and interpreted
              exactly as provided.
            </p>
            <p>
              <span>
                <strong>Best For:</strong>
              </span>
              Simple, straightforward queries where no additional context,
              decomposition, or modifications are needed. Ideal for precise
              lookups or when the query structure is already well-defined.
            </p>
            <p>
              <span>
                <strong>Advantages:</strong>
              </span>
              Fast and efficient processing with minimal latency and
              computational cost.
            </p>
            <p>
              <span>
                <strong>Disadvantages:</strong>
              </span>
              May not capture complex relationships or context that could
              improve retrieval accuracy for more nuanced queries.
            </p>
            <br />

            <p>
              <span style={{ fontSize: "1.0rem" }}>Multi-phrasing:</span>
            </p>
            <p>
              <span>What It Does:</span> Rephrases the query in multiple ways to
              explore different linguistic expressions and perspectives of the
              same question, broadening the scope of results.
            </p>
            <p>
              <span>Best For:</span> Use when queries might be interpreted in
              various ways or when looking for diverse answers from the data,
              such as user-generated content or feedback analysis.
            </p>
            <p>
              <span>Advantages:</span> Expands the range of results by capturing
              varied expressions of the query, improving coverage and recall.
            </p>
            <p>
              <span>Disadvantages:</span> Can introduce irrelevant results if
              not well-tuned, as variations might stray too far from the
              original intent of the query.
            </p>
            <br />

            <p>
              <span style={{ fontSize: "1.0rem" }}>
                HyDE (Hypothetical Document Embedding):
              </span>
            </p>
            <p>
              <span>What It Does:</span> Generates a hypothetical answer or
              document based on the query and uses this generated text to
              perform retrieval, essentially searching for documents that are
              most similar to the hypothetical answer.
            </p>
            <p>
              <span>Best For:</span> Complex, open-ended, or abstract questions
              where direct search might miss relevant information. Great for
              exploratory searches where you're not exactly sure what the
              precise answer looks like.
            </p>
            <p>
              <span>Advantages:</span> Helps uncover hidden connections by
              broadening the retrieval to align with the intent rather than just
              the words of the query.
            </p>
            <p>
              <span>Disadvantages: </span>May introduce noise if the
              hypothetical document doesn't closely align with the actual
              relevant data, requiring careful balancing of generation quality.
            </p>
            <br />

            <p>
              <span style={{ fontSize: "1.0rem" }}>Deconstruction:</span>
            </p>
            <p>
              <span>What It Does: </span>Breaks down complex queries into
              simpler, more manageable sub-queries, enhancing the system’s
              ability to retrieve relevant parts of information individually
              before recomposing them.
            </p>
            <p>
              <span>Best For: </span>Use in scenarios where queries are
              multi-faceted, layered, or too complex to handle in a single
              retrieval pass—like legal documents, research papers, or detailed
              data analysis tasks.
            </p>
            <p>
              <span>Advantages: </span> Improves retrieval accuracy by focusing
              on each element of a complex question, ensuring no aspect is
              overlooked.
            </p>
            <p>
              <span>Disadvantages: </span> Can be computationally intensive, as
              it requires multiple retrieval passes and reassembly, making it
              less efficient for simple queries.
            </p>
            <br />

            <p>
              <span style={{ fontSize: "1.0rem" }}>Expansion:</span>
            </p>
            <p>
              <span>What It Does:</span> Expands a user query by incorporating
              additional context from the problem statement and adding relevant
              keywords to improve retrieval accuracy.
            </p>
            <p>
              <span>Best For:</span> Scenarios where user questions require
              additional context for precise lookup, such as broad or loosely
              defined queries.
            </p>
            <p>
              <span>Disadvantages:</span> Includes an additional LLM call, which
              slightly increases cost and latency.
            </p>
            <br />

            <p>
              <span style={{ fontSize: "1.0rem" }}>
                Iterative Deconstruction:
              </span>
            </p>
            <p>
              <span>What It Does:</span> Breaks down complex queries into
              step-by-step sub-queries. Context is retrieved for the initial
              sub-query, and subsequent sub-queries are generated based on the
              available information.
            </p>
            <p>
              <span>Best For:</span> Complex, multi-hop questions that require
              incremental retrieval and processing for comprehensive answers.
            </p>
            <p>
              <span>Disadvantages:</span> High latency due to the iterative
              process, making it less efficient for simple or straightforward
              queries.
            </p>
            <br />
            <p>
              <span style={{ fontSize: "1.0rem" }}>
                Choosing the Right Query Transformation Method:
              </span>
            </p>
            <p>
              <span>
                <strong>None:</strong>
              </span>
              Use this option when no transformation is required. Ideal for
              straightforward queries where the input should be processed
              exactly as it is.
            </p>
            <p>
              <span>
                <strong>Multi-phrasing:</strong>
              </span>
              Use this method when you need to explore varied perspectives of a
              query or broaden the scope of search results. Ideal for situations
              where queries can be interpreted in multiple ways, such as
              analyzing user feedback or user-generated content.
            </p>
            <p>
              <span>
                <strong>HyDE (Hypothetical Document Embedding):</strong>
              </span>
              Select this method for abstract, open-ended, or exploratory
              questions where traditional searches might miss relevant
              information. It's particularly effective for finding hidden
              connections and tackling complex questions with no precise answer.
            </p>
            <p>
              <span>
                <strong>Deconstruction:</strong>
              </span>
              Choose this when your queries are multi-faceted, layered, or too
              complex to handle in a single retrieval pass. Best for legal
              documents, research papers, or detailed data analysis tasks
              requiring high precision.
            </p>
            <p>
              <span>
                <strong>Iterative Deconstruction:</strong>
              </span>
              Opt for this method when solving complex multi-hop questions that
              require step-by-step processing. It’s ideal for queries that need
              incremental retrieval and logical progression to derive a complete
              answer.
            </p>
            <p>
              <span>
                <strong>Expansion:</strong>
              </span>
              Use this method when queries require additional context for
              accurate results. It’s best suited for broad or loosely defined
              queries that need to incorporate keywords and contextual
              information for proper retrieval.
            </p>
            <p>
              <span style={{ fontSize: "1.0rem" }}>
                Creating Custom Query Chains:
              </span>
            </p>
            <p>
              You can select a query transformation method from the available
              options or create custom query chains by combining multiple
              transformations. Use the 'Add Query Chain' button to build and
              arrange your sequence for tailored results.
            </p>
          </div>
        )}
        {type === "document_parser" && (
          <div className="side-bar_contents_info retrieval-method">
            <h1>Document Parser</h1>

            <p>
              Selecting the right document parser depends on your data type and
              analysis needs. Each method has unique strengths and limitations,
              making it important to choose the one that aligns with your use
              case.
            </p>

            <p>
              <span style={{ fontSize: "1.0rem" }}>
                <strong>Basic Parser:</strong>
              </span>
            </p>
            <p>
              <span>
                <strong>What It Does:</strong>
              </span>{" "}
              Loads the document page by page, focusing on extracting text
              content efficiently.
            </p>
            <p>
              <span>
                <strong>Best For:</strong>
              </span>{" "}
              Structured data and unstructured data that does not include
              tables, figures, charts, equations, or images.
            </p>
            <p>
              <span>
                <strong>Disadvantages:</strong>
              </span>{" "}
              Ignores images and struggles with parsing tables accurately,
              leading to errors in table data.
            </p>
            <br />

            <p>
              <span style={{ fontSize: "1.0rem" }}>
                <strong>Llama Parse:</strong>
              </span>
            </p>
            <p>
              <span>
                <strong>What It Does:</strong>
              </span>{" "}
              Reconstructs tables in markdown format and generates descriptive
              text for images, figures, and charts, preserving visual data in a
              structured format.
            </p>
            <p>
              <span>
                <strong>Best For:</strong>
              </span>{" "}
              Unstructured data containing tables, figures, charts, or equations
              that require structured representation for analysis.
            </p>
            <p>
              <span>
                <strong>Disadvantages:</strong>
              </span>{" "}
              Slower document processing and slightly higher ingestion costs due
              to its enhanced capabilities.
            </p>
            <br />

            <p>
              <span style={{ fontSize: "1.0rem" }}>
                <strong>Unstructured.io:</strong>
              </span>
            </p>
            <p>
              <span>
                <strong>What It Does:</strong>
              </span>{" "}
              Similar to LlamaParse, this method recreates tables in markdown
              format and generates descriptive text for images and figures,
              ensuring better handling of unstructured data.
            </p>
            <p>
              <span>
                <strong>Best For:</strong>
              </span>{" "}
              Unstructured data containing tables, figures, charts, or equations
              where detailed representations are required.
            </p>
            <p>
              <span>
                <strong>Disadvantages:</strong>
              </span>{" "}
              Slower document processing and slightly higher ingestion costs,
              comparable to LlamaParse.
            </p>
            <br />
            <p>
              <span style={{ fontSize: "1.0rem" }}>
                <strong>Choosing the Right Document Parser:</strong>
              </span>
            </p>
            <p>
              <span>
                <strong>Basic Parser:</strong>
              </span>{" "}
              Ideal for structured or simple unstructured data without tables,
              figures, or charts. Fast and efficient, but it may miss critical
              details in complex data.
            </p>
            <p>
              <span>
                <strong>LlamaParse:</strong>
              </span>{" "}
              Best for unstructured data with tables, figures, or equations. It
              excels at recreating tables and describing visuals but has slower
              processing and higher costs.
            </p>
            <p>
              <span>
                <strong>Unstructured.io:</strong>
              </span>{" "}
              Similar to LlamaParse, it handles complex unstructured data
              effectively but also involves slower processing and higher costs.
            </p>
            <p>
              For simple tasks, choose the Basic Parser. For detailed, data-rich
              documents, LlamaParse or Unstructured.io offers better accuracy
              and representation.
            </p>
          </div>
        )}
        {type === "top_k" && (
          <div className="side-bar_contents_info top-k">
            <h1>Top K</h1>
            <p>
              Top K is a retrieval method that allows you to set a specific
              limit on the number of documents returned from a search. By
              choosing a value for “K,” you directly control the number of
              results displayed, ensuring that only the most relevant documents
              are presented.
            </p>
            <br />
            <p>
              <span>What It Does:</span> Limits the number of documents
              retrieved by the search to the top K results, ranked by their
              relevance to the query. For instance, if you set K = 5, the system
              will return the five highest-ranked documents.
            </p>
            <p>
              <span>Best For:</span> Use when you want to streamline the results
              and focus on the most relevant content, especially in scenarios
              where too many results would be overwhelming or unnecessary, such
              as in customer support, product searches, or targeted research.
            </p>
            <br />

            <p>
              <span style={{ fontSize: "1.0rem" }}>Advantages:</span>
            </p>

            <p>
              <span></span>Efficiency: Helps manage large volumes of data by
              only presenting the most pertinent information, reducing noise and
              irrelevant content.
            </p>
            <p>
              <span>Simplicity: </span>Easy to implement and understand, making
              it ideal for straightforward retrieval tasks where only the top
              matches matter.
            </p>
            <p>
              <span>Control:</span> Gives users direct control over the breadth
              of results, allowing them to adjust the scope based on the context
              or complexity of their needs.
            </p>
            <br />

            <p>
              <span style={{ fontSize: "1.0rem" }}>Disadvantages:</span>
            </p>
            <p>
              <span>Potentially Missed Information:</span> By limiting results,
              there is a risk of overlooking less relevant but still useful
              information that lies beyond the top K threshold.
            </p>
            <p>
              <span>Context Loss:</span>For highly nuanced or complex queries,
              restricting results might exclude valuable context that would
              otherwise be captured in a broader search.
            </p>
            <br />
            <p>
              <span style={{ fontSize: "1.0rem" }}>Choosing the Right K:</span>
            </p>
            <p>
              <span>Smaller K Values (e.g., K = 1 to 5):</span> Best when
              precision is critical, and you want the most focused, relevant
              answers without distraction.
            </p>
            <p>
              <span>Larger K Values (e.g., K = 10 or 20):</span> Use when you
              need a wider range of insights or are exploring more complex
              queries that benefit from a broader view of relevant documents.
            </p>
            <br />
            <p>
              <span></span>Top K is an adaptable retrieval strategy that
              empowers users to refine search outputs according to their
              specific needs, balancing between efficiency and comprehensiveness
              based on the task at hand.
            </p>
          </div>
        )}
        {type === "metadata_filtering" && (
          <div className="side-bar_contents_info top-k">
            <h1>Metadata Filtering</h1>
            <p>{metadataFilteringInfo}</p>
            <p>
              When doing a similarity search, you can specify filters on the
              metadata to narrow down the results
            </p>
            <h3 style={{ width: "250px" }}>
              {"filter = {'field': 'fullstack'}"}
            </h3>
            <p>
              This would retrieve only resumes of field "fullstack". Other
              documents would be filtered out, even if they were close matches
              textually.
            </p>
            <br />
            <br />
            <h1>Current Available Metadata:</h1>
            <br />
            <p>
              <span>Creation Date - </span> Document creation date.
            </p>
            <p>
              <span>Document Category - </span> A document category is like
              putting documents into big groups, such as "technology,"
              "experience," or "education." Metadata filtering tags are like
              little labels that we can add to a document to tell us more about
              what's inside. For instance, we can tag an article with labels
              like "work experience" and "skills" to show what it's about in
              detail.
            </p>
            <p>
              We can also tag document as "Resume" or "Cover letter" to
              differentiate between them.
            </p>
            <p>
              These tags help us find and organize documents in different ways.
              For example, if we want to see all the resumes about "education"
              in "Computer Science" we can use the tag to filter and get a list.
              Or, if we're interested in "artificial intelligence" we can use
              its tag to find all documents related to AI.
            </p>
          </div>
        )}
        {type === "problem_statement" && (
          <div className="side-bar_contents_info top-k">
            <h1>Problem Statement</h1>
            <p>
              A problem statement is a clear and concise description of an issue
              or challenge that needs to be addressed. It outlines the key
              aspects of the problem, the context in which it occurs, and its
              significance, serving as the foundation for developing a targeted
              solution.
            </p>
            <br />
            <p>
              <span>Example Problem Statement:</span>
            </p>
            <p>
              The objective is to build an AI-powered system designed to
              retrieve resumes from a large database efficiently. The system
              should:
            </p>
            <p>
              Handle resumes in multiple formats, such as PDFs and Word
              documents.
            </p>
            <p>Process large volumes of data quickly and accurately.</p>
            <p>
              Retrieve the correct resumes based on user queries, providing
              precise and relevant responses.
            </p>
            <p>
              <span>Example Use Case:</span>
            </p>
            <p>
              <span>Question:- </span> Retrieve candidates with 4 years of
              experience in Python and JavaScript for Fullstack Development.
            </p>
            <p>
              <span>Answer:- </span> Based on the resumes, two candidates fit
              the criteria for Fullstack Development:
            </p>
            <p>
              John Doe, Six years of experience in JavaScript and Python, with
              significant contributions to the development and deployment of
              multiple full-stack projects
            </p>
            <p>
              James A., Four years of experience in JavaScript and Python,
              involved in developing and deploying various full-stack projects.
            </p>
          </div>
        )}
        {type === "golden_responses" && (
          <div className="side-bar_contents_info top-k">
            <h1>Golden Responses</h1>
            <p>
              Golden responses are predefined benchmark answers used to evaluate
              the performance and accuracy of chatbot-generated responses. They
              act as reference points, allowing queryloop to compare the
              chatbot's outputs against expected results to assess whether the
              responses meet specific criteria.
            </p>
            <p>
              <span style={{ fontSize: "1.0rem" }}>Purpose:</span>
            </p>
            <p>
              Golden responses help determine if the chatbot provides correct,
              complete, and contextually relevant answers. By comparing
              generated responses to these benchmarks, you can identify areas
              where the chatbot performs well and where it needs improvement,
              ensuring that the system meets the desired standards.
            </p>
            <p>
              <span style={{ fontSize: "1.0rem" }}>Example:</span>
            </p>
            <p>
              <span>Question:- </span> Retrieve candidates with 4 years of
              experience in Python and JavaScript for Fullstack Development
            </p>
            <p>
              <span>Answer:- </span> Based on the resumes, two candidates fit
              the criteria for Fullstack Development:
            </p>
            <p>
              John Doe, Six years of experience in JavaScript and Python, having
              contributed to the development and deployment of multiple
              full-stack projects.
            </p>
            <p>
              James A., Four years of experience in JavaScript and Python,
              actively involved in the development and deployment of multiple
              full-stack projects.
            </p>

            <p>
              <span style={{ fontSize: "1.0rem" }}>
                How to Add Golden Responses:
              </span>
            </p>
            <p>
              <span>Manual Entry:</span>You can add golden responses directly
              through the interface by inputting the question and answer pairs.
            </p>
            <p>
              <span>CSV Upload:</span> Golden responses can also be uploaded via
              a CSV file. The file must follow the format: `question,answer.`
            </p>
          </div>
        )}
        {type === "datasets" && (
          <div className="side-bar_contents_info embedding">
            <h1>Upload Dataset</h1>
            <br />
            <h1 style={{ fontSize: "0.9rem" }}>Dataset type</h1>
            <p>
              <span>Structured:</span>
            </p>
            <p>
              <span></span>Structured data refers to information that is
              organized in a predefined format, such as tables or spreadsheets,
              where relationships between data points are explicitly defined.
              Examples include CSV and XLS files. Non-textual fields and small
              text fields, like numerical values, categories, or string tags,
              are automatically recognized as metadata, which facilitates
              efficient filtering and retrieval.
            </p>
            <p>
              <span></span>With Queryloop, you can seamlessly perform both
              natural language queries and semantic searches over your databases
              within the same application, enhancing your data accessibility and
              search capabilities.
            </p>
            <br />
            <p>
              <span>Unstructured:</span>
            </p>
            <p>
              <span></span> Unstructured data includes information that does not
              follow a specific format, such as free-form text found in
              documents like PDFs, TXT, and DOC files.
            </p>
            <p>
              <span>Unstructured with metadata: </span>
            </p>
            <p>
              <span></span>Unstructured with metadata refers to unstructured
              data that is enhanced with additional information, such as tags or
              fields, that describe key characteristics of the document. For
              example, a document might have metadata like
              {`'field': 'LLM development'`} or {`'field': 'Business'`}.
            </p>
            <p>
              <span></span>This metadata helps categorize and filter documents
              during searches, allowing you to apply specific filters based on
              these tags. By using metadata filtering, you can target specific
              types of documents, significantly improving the precision and
              accuracy of retrieval, especially for complex or focused queries.
            </p>
            <br />
            <p>
              <span style={{ fontSize: "1.0rem" }}>
                Data Type Upload Limitations
              </span>
            </p>
            <p>
              <span></span>When uploading data to Queryloop, it's important to
              understand the current limitations and compatibility between
              different data types to ensure seamless integration. These
              restrictions will be lifted with the upcoming agentic RAG. Here's
              a summary of the current restrictions:
            </p>
            <p>
              <span>Allowed Combinations:</span>
            </p>
            <p>
              <span>Unstructured Data Files with Structured Data Files: </span>
              These can be mixed freely, allowing the system to handle both
              formats within the same bot.
            </p>
            <p>
              <span>Unstructured Data with and Without Metadata: </span>You can
              mix unstructured data files with and without metadata, but the
              metadata format must remain consistent across all metadata
              uploads.
            </p>

            <br />
            <p>
              <span style={{ fontSize: "1.0rem" }}>Restrictions:</span>
            </p>
            <p>
              <span>Structured Data with Unstructured Data with Metadata:</span>
              You cannot upload structured data to a bot that is configured to
              handle unstructured data with metadata. Currently, the formats and
              processing methods differ significantly, making them incompatible
              in a mixed setting.
            </p>
            <p>
              <span>
                Unstructured Data with Metadata on Structured Data Bot:
              </span>
              Similarly, you cannot upload unstructured data with metadata to a
              bot designed to handle structured data only, as the metadata
              handling and retrieval requirements differ.
            </p>
            <p>
              <span>Inconsistent Metadata Formats:</span> If you are working
              with unstructured data with metadata, all metadata must follow the
              same format. Mixing different metadata structures within the same
              bot setup is not supported and will result in errors.
            </p>
            <br />

            <h1>Confidentiality:</h1>
            <p>
              <span></span>Confidentiality settings control access to documents,
              ensuring that only authorized users can view specific content.
              These settings help match document access levels with user
              privileges, which are assigned when users are created. Based on
              these privileges, users can query and retrieve data that aligns
              with their access level.
            </p>
            <p>
              <span>Public: </span>Documents labeled as public can be accessed
              by all users, regardless of their privilege level. This setting is
              suitable for general information that doesn't require restricted
              access.
            </p>
            <p>
              <span>Private: </span>Documents marked as private are accessible
              only to specific users or groups with the necessary permissions.
              This setting is ideal for sensitive information that needs to be
              restricted to a defined set of users.
            </p>
            <p>
              <span>Confidential:</span> This level is for highly sensitive or
              restricted documents, where access is tightly controlled and
              limited to users with the highest privileges. It's best used for
              proprietary, legal, or classified information that must be
              safeguarded against unauthorized access.
            </p>
            <br />
            <br />
            <p>
              <span></span>These confidentiality settings ensure that each user
              interacts only with the data they are authorized to see, enhancing
              data security.
            </p>
          </div>
        )}
        {type === "base_prompt" && (
          <div className="side-bar_contents_info top-k">
            <h1>Prompt</h1>
            <p>
              A prompt is essentially a set of instructions or a query that you
              provide to a language model to specify the kind of response you
              want from it. It's like telling the model what you'd like to know
              or discuss. For instance, you can use a prompt to ask a language
              model to summarize a text, translate a sentence, or answer a
              question. The quality and clarity of the prompt are crucial in
              obtaining the desired output from the model. It serves as a way to
              guide the model's responses, making it a key component in
              interacting with AI systems.
            </p>
          </div>
        )}
        {type === "generation" && (
          <div className="side-bar_contents_info top-k">
            <h1>Generation Node</h1>
            <br />
            <h1 style={{ fontSize: "0.9rem" }}>LLM</h1>

            <p>
              <span>Foundation models</span>
            </p>
            <p>
              <span></span>Foundation models are large, pre-trained language
              models that serve as the backbone for generating text in RAG
              systems. These models have been trained on vast amounts of data
              and can generate coherent and contextually relevant text based on
              the input provided. In the RAG setup, you can select from
              different foundational models such as OpenAI, Meta AI, Anthropic,
              Google AI, and Mistral AI models, each offering unique strengths
              and capabilities:
            </p>
            <p>
              <span>OpenAI Models:</span> Known for their powerful language
              understanding and generation abilities, suitable for a wide range
              of applications.
            </p>
            <p>
              <span>Meta AI Models:</span> Designed for specialized tasks, Meta
              models bring specific insights and optimizations.
            </p>
            <p>
              <span>Anthropic Models: </span>Focus on safe and ethical AI
              interactions, emphasizing high-quality and less biased outputs.
            </p>
            <p>
              <span>Google AI Models:</span> Leverage Google’s advanced language
              capabilities, including context comprehension and multilingual
              support.
            </p>
            <p>
              <span>Mistral AI Models:</span> Known for their efficiency and
              adaptability in language tasks, providing alternatives tailored
              for specific applications.
            </p>
            <br />
            <p>
              <span>Temperature</span>
            </p>
            <p>
              <span></span>Description: Temperature controls the randomness of
              the generated output. A lower temperature (close to 0) makes the
              model's responses more focused and deterministic, often repeating
              common patterns or known facts. A higher temperature (closer to 1)
              introduces more randomness, creativity, and diversity in the
              generated text.
            </p>
            <p>
              <span>Best For:</span>
            </p>
            <p>
              <span>Low Temperature (e.g., 0.0 - 0.3):</span> Use when you need
              precise, fact-based, and consistent answers, such as in technical
              or scientific content.
            </p>
            <p>
              <span>Medium Temperature (e.g., 0.4 - 0.6):</span> Balances
              creativity and accuracy, suitable for conversational or advisory
              outputs.
            </p>
            <p>
              <span>High Temperature (e.g., 0.7 - 1.0):</span> Ideal for
              creative writing, brainstorming, or when diverse and imaginative
              responses are desired.
            </p>
            <p>
              <span>Recommendation:</span> Adjust the temperature based on the
              desired level of creativity versus reliability in the generated
              output.
            </p>
            <br />

            <p>
              <span>Output token limit</span>
            </p>
            <br />
            <p>
              <span>Output Token Limit (0 equals no limit)</span>
            </p>
            <p>
              <span></span>Description: The output token limit defines the
              maximum number of tokens (words or word fragments) the model can
              generate in response to a prompt. Setting this limit helps control
              the length of the output, ensuring it remains concise or allowing
              it to expand as needed.
            </p>
            <p>
              <span>Best For:</span>
            </p>
            <p>
              <span>Low Limits (e.g., 50 - 200 tokens):</span> Suitable for
              brief answers, summaries, or targeted responses.
            </p>
            <p>
              <span>Higher Limits (e.g., 200 - 2000 tokens):</span> Use when
              detailed explanations, extended dialogue, or comprehensive content
              generation is required.
            </p>

            <br />
            <br />
            <h1>Prompt for Foundational LLMs</h1>
            <p>
              <span>Prompt Types</span>
            </p>
            <br />
            <p>
              <span>Zero Shot:</span> Generates responses without any examples,
              relying solely on the model's knowledge. Best for straightforward
              queries.
            </p>
            <p>
              <span>Few Shot:</span> Users upload examples that are directly
              included in the prompt to guide the model's response style. Ideal
              for consistent, example-driven outputs.
            </p>
            <p>
              <span>Random Few Shot:</span> The LLM generates random examples
              based on the problem statement, which are then included in the
              prompt. Great for exploring varied response styles.
            </p>
            <p>
              <span>Dynamic Few Shot:</span> Uploaded examples are stored in a
              vector database, and relevant ones are retrieved at query time and
              appended to the prompt. Best for context-specific guidance.
            </p>
            <p>
              <span>Chain of Thought (CoT): </span>Guides the model to think
              step-by-step, enhancing logical reasoning in complex queries.
            </p>
            <p>
              <span>Few Shot CoT Random:</span> Combines few-shot learning with
              random step-by-step examples, adding depth and varied reasoning to
              responses.
            </p>

            <br />
            <p>
              <span>Generate prompt</span>
            </p>
            <p>
              <span></span>The Generate Prompt feature automatically adapts the
              chosen prompt types (e.g., Zero Shot, Few Shot, Dynamic Few Shot)
              to align with the user's problem statement. This ensures that the
              foundational model receives contextually relevant guidance
              tailored to the specific task, enhancing the quality and accuracy
              of the generated responses. The initial prompt, such as "You are a
              helpful assistant," sets the base tone, while the generate prompt
              function refines it to suit the unique needs defined by the user’s
              selected prompt type and problem statement.
            </p>
            <br />
            <p>
              <span>Initial prompt</span>
            </p>
            <p>
              <span></span>The Initial Prompt section displays the generated
              prompts tailored according to the selected prompt type (e.g., Zero
              Shot, Few Shot, Chain of Thought) and the provided problem
              statement. These prompts serve as the starting point for guiding
              the language model’s responses, aligning them with the desired
              context and style.
            </p>
            <br />
            <p>
              <span>Editable Prompts:</span>
            </p>
            <p>
              <span></span>The user can review and modify these initial prompts
              before finalizing them for use with the chatbot. This feature
              provides flexibility, allowing you to refine the instructions to
              better suit your specific needs or preferences, ensuring that the
              bot performs as intended.
            </p>
            <br />
            <br />

            <h1>Fine-tuning</h1>
            <p>
              <span>Fine-Tuning Overview</span>
            </p>
            <p>
              <span></span>Fine-tuning allows you to adjust pre-trained language
              models to better suit your specific needs by training them further
              on custom data. This process adapts the model’s behavior to align
              with your task requirements, response style, or domain-specific
              knowledge.
            </p>
            <br />

            <p>
              <span>Available Models for Fine-Tuning</span>
            </p>
            <p>
              <span>gpt4o-mini-2024-07-18:</span> Requires the user to provide
              their own OpenAI API key in the settings. OpenAI fine-tuning
              adjusts how the model generates responses according to the
              training data but does not add new knowledge directly into the
              model.
            </p>
            <p>
              <span>llama-3-8b: </span>Fine-tuned using the parameter-efficient
              QLoRA technique, which focuses on updating a small subset of model
              parameters, making it a resource-efficient option. This method
              allows for incorporating new knowledge into the model, although
              the knowledge gained is less extensive compared to full
              fine-tuning.
            </p>
            <p>
              <span>More coming soon</span>
            </p>
            <br />

            <p>
              <span></span>Fine-tuning performance is heavily influenced by
              hyperparameters like epoch, batch size, and learning rate and rank
              and alpha in case of QLoRA. Hyperparameters play a critical role
              in the fine-tuning process, affecting how well the model learns
              from the training data.
            </p>
            <p>
              <span></span>Queryloop provides an automated way to iterate over
              various hyperparameter combinations to find the one that minimizes
              validation loss, enhancing the model’s performance.
            </p>
            <p>
              <span></span>Users can view training loss and full validation loss
              at the end, which serves as a key indicator of the model’s
              accuracy and alignment with the training data.
            </p>
            <br />

            <p>
              <span>Training Data Requirements</span>
            </p>
            <p>
              <span></span>The user must upload training data in CSV format with
              columns: system_prompt, query, and response.
            </p>
            <p>
              <span></span>The data is split into 90% for training and 10% for
              validation. The validation loss calculated on this split helps
              measure the fine-tuned model’s effectiveness.
            </p>
            <br />

            <p>
              <span>Key Points</span>
            </p>

            <p>
              <span>OpenAI Fine-Tuning:</span> Aligns response generation but
              does not integrate new knowledge.
            </p>
            <p>
              <span>Llama-3-8b Fine-Tuning:</span> Adds knowledge using QLoRA,
              suitable for open-source model adjustments.
            </p>
            <p>
              <span>Hyperparameter Optimization:</span> Automates the search for
              the best parameter set to reduce validation loss.
            </p>
            <p>
              <span></span>Fine-tuning in Queryloop allows users to customize
              models for specific use cases, making the generated responses more
              aligned with the desired output, while also offering insights into
              model performance through loss metrics.
            </p>

            <br />
            <h1>Optimization method</h1>
            <p>
              <span></span>Fine-tuning in Queryloop offers two optimization
              methods—Grid Search and Bayesian Optimization—to find the best
              hyperparameters that minimize validation loss. These methods help
              tailor the model's performance by systematically exploring
              different combinations of hyperparameters.
            </p>
            <p>
              <span>Grid Search</span>
            </p>
            <p>
              <span>Description:</span> Grid Search evaluates all possible
              combinations of predefined discrete values for each
              hyperparameter, creating a complete grid. It tests each
              combination to identify which set of parameters works best.
            </p>
            <p>
              <span>Execution:</span> Each combination of hyperparameters is
              tested independently, and users can view the validation loss for
              each. The process can run in parallel across multiple machines,
              speeding up the exploration.
            </p>
            <p>
              <span>Use Case:</span> Ideal for comprehensive exploration when
              you have specific discrete values to test. It allows users to
              directly compare the impact of each combination on the validation
              loss.
            </p>
            <p>
              <span>Output: </span>Users can review the validation loss
              associated with each combination and select the best-performing
              configurations to further test on golden responses.
            </p>

            <br />
            <p>
              <span>Bayesian Optimization</span>
            </p>
            <p>
              <span>Description:</span> Unlike Grid Search, Bayesian
              Optimization starts with a range of possible values for each
              hyperparameter. It begins with 3 initial random combinations
              within the specified ranges and uses a Bayesian approach to
              suggest subsequent combinations aimed at reducing validation loss.
            </p>
            <p>
              <span>Execution:</span> After the initial 3 random trials, the
              process continues sequentially, suggesting new combinations that
              are predicted to perform better based on previous results, up to a
              total of 10 iterations.
            </p>
            <p>
              <span>Use Case:</span> Suitable for optimizing within a continuous
              range of hyperparameter values, focusing on minimizing validation
              loss more efficiently by predicting the next best combination
              rather than testing every possibility.
            </p>
            <p>
              <span>Output:</span> The best model is presented after 10
              iterations, and users can view the training and validation losses
              for each fine-tuning round.
            </p>
            <br />
            <p>
              <span>Comparison of Methods</span>
            </p>
            <p>
              <span>Grid Search:</span> Offers exhaustive testing of all
              combinations, which can be run in parallel, but is time-consuming
              if the grid is large.
            </p>
            <p>
              <span>Bayesian Optimization: </span>More strategic and efficient,
              focusing on promising areas of the parameter space, but runs
              sequentially after the initial random trials.
            </p>

            <br />
            <p>
              <span></span>These methods provide flexibility in fine-tuning,
              allowing users to choose between a comprehensive approach with
              Grid Search or a more predictive, resource-efficient method with
              Bayesian Optimization. Both methods aim to identify the optimal
              hyperparameter settings that lead to the lowest validation loss,
              enhancing the model’s performance for specific tasks.
            </p>
            <br />
            <p>
              <span>Epoch</span>
            </p>
            <p>
              <span>Description: </span>An epoch refers to one complete pass
              through the entire training dataset during the fine-tuning
              process. Each epoch allows the model to update its weights based
              on the patterns it learns from the data.
            </p>
            <p>
              <span>Recommendation:</span> Start with 1-3 epochs
            </p>
            <p>
              <span>Impact:</span> More epochs enable the model to learn better,
              but too many can lead to overfitting, where the model performs
              well on training data but poorly on unseen data.
            </p>
            <br />
            <p>
              <span>Batch size</span>
            </p>
            <p>
              <span>Description:</span> Batch size defines the number of
              training examples the model processes before updating its weights.
              Larger batch sizes can lead to faster training but require more
              memory and may smooth out the learning process.
            </p>
            <p>
              <span>Impact:</span> A smaller batch size provides more updates to
              the model per epoch, potentially leading to better generalization
              but with longer training times.
            </p>
            <p>
              <span>Recommendation:</span> Use a moderate batch size (e.g.,
              16-32) to balance training speed and memory usage.
            </p>
            <br />
            <p>
              <span>Learning rate multiplier</span>
            </p>
            <p>
              <span>Description:</span> The learning rate controls the step size
              at each iteration while moving toward a minimum of the loss
              function. It dictates how much the model adjusts its weights with
              respect to the loss gradient.
            </p>
            <p>
              <span>Impact:</span> A high learning rate can speed up training
              but risks overshooting optimal values, while a low learning rate
              allows for precise adjustments but slows down training.
            </p>
            <p>
              <span>Recommendation:</span> Start with learning rate between (
              0.0001 - 0.001)
            </p>
            <br />

            <p>
              <span style={{ fontSize: "1.0rem" }}>QLoRA</span>
            </p>
            <p>
              <span>Rank</span>
            </p>
            <p>
              <span>Description:</span> QLoRA (Quantized Low-Rank Adaptation)
              rank determines the number of low-rank matrices used to
              approximate the large model's parameters. This approach reduces
              the number of parameters that need to be fine-tuned, making the
              process more efficient.
            </p>
            <p>
              <span>Impact:</span> Higher ranks increase the model’s capacity to
              learn complex patterns but require more computational resources.
              Lower ranks are more efficient.
            </p>
            <br />

            <p>
              <span>Alpha/Rank Ratio</span>
            </p>
            <p>
              <span>Description:</span> The Alpha/Rank ratio controls the
              scaling of the low-rank updates in QLoRA, effectively balancing
              the influence of fine-tuning adjustments relative to the base
              model parameters.
            </p>
            <p>
              <span>Impact:</span> A higher ratio increases the effect of the
              learned updates, while a lower ratio maintains more of the
              original model behavior.
            </p>
            <br />
            <p>
              <span>Upload CSV</span>
            </p>
            <p>
              <span></span>The user must upload training data in CSV format with
              columns: system_prompt, query, and response.
            </p>
          </div>
        )}
        {type === "optimization_method" && (
          <div className="side-bar_contents_info top-k">
            <h1>Optimization Method</h1>
            <br />
            <p>
              <span>Grid Search:</span>
            </p>
            <p>
              This method involves methodically testing every possible
              combination of parameters you've selected. Imagine it like
              checking every square on a chessboard to find the best move. The
              app will use your ideal answers as a target and try each set of
              parameters to see which one gets the closest to your target
              response. It's thorough but can take longer, especially if there
              are many combinations to check.
            </p>
            <br />
            <br />
            <p>
              <span>1-D Search:</span>
            </p>
            <p>
              Think of this method as a step-by-step approach. It starts by
              adjusting one parameter at a time and finding the best setting for
              that specific parameter. Once it finds the best setting for the
              first parameter, it 'locks' that in place and moves on to optimize
              the next one, building on the success of the previous step. This
              way, it goes through each parameter individually, which can be
              faster than checking all possible combinations at once but might
              not be as thorough as the Grid Search.
            </p>
            <br />
            <br />
            <p>
              <span>Random Search:</span>
            </p>
            <p>
              This method is a bit like a lottery. Instead of methodically
              checking each combination, it randomly selects different parameter
              settings to try. Behind the scenes, the app uses smart algorithms
              to guide this random selection, learning from each attempt to
              improve the chances of finding a good combination. This can
              sometimes find a good solution faster than Grid Search, especially
              when there are too many combinations to test each one
              individually. However, it relies on chance, so it might not always
              find the best possible combination like Grid Search does.
            </p>
            <br />
            <br />
            <p>
              <span>
                Each method has its pros and cons, and the right choice might
                depend on how many parameters you're working with, how much time
                you have, and what kind of precision you need.
              </span>
            </p>
          </div>
        )}
        {type === "question_metadata" && (
          <div className="side-bar_contents_info top-k">
            <h1>Document Categorization</h1>
            <br />
            <p>
              Will your queries focus on specific document types? If so,
              consider using metadata filtering to enhance retrieval accuracy
              and ensure your queries target the most relevant documents
            </p>
          </div>
        )}
        {type === "question_metadata-subcontents" && (
          <div className="side-bar_contents_info top-k">
            <h1>Query Focus</h1>
            <br />
            <p>
              Are your queries designed to explore a single document type per
              query, or do they encompass all document types simultaneously?
              Your choice here helps determine the precision and scope of the
              retrieval process
            </p>
          </div>
        )}
        {type === "question_metadata_info" && (
          <div className="side-bar_contents_info top-k">
            <h1>Document Category Weighting</h1>
            <br />
            <p>
              Indicate whether you assign equal significance to each document
              category or prioritize certain ones for credibility and relevance.
              This helps tailor the LLM's prompt to better align with your
              specific requirements
            </p>
          </div>
        )}
        {type === "question_twr" && (
          <div className="side-bar_contents_info top-k">
            <h1>Recent Documents</h1>
            <br />
            <p>
              Your preference will be incorporated into the prompt provided to
              the LLM
            </p>
          </div>
        )}
        {type === "question_embedding-model" && (
          <div className="side-bar_contents_info top-k">
            <h1>Embedding Optimization</h1>
            <br />
            <p></p>
          </div>
        )}
        {type === "question_sentence-window" && (
          <div className="side-bar_contents_info top-k">
            <h1>Text Chunking and Retrieval Impact</h1>
            <br />
            <p>
              All documents are segmented into chunks before being stored. The
              chunks most relevant to a user's query are retrieved and passed to
              a language model. If you think that segmenting the text might
              hinder its comprehensibility, we recommend using a
              <b>'sentence window'</b> retrieval method. This approach appends
              the text preceding and following the retrieved segment to provide
              better context.
            </p>
            <p>
              If your documents are small, it's advisable to opt for larger
              chunk sizes to ensure that your documents remain unchunked.
            </p>
          </div>
        )}
        {type === "question_response-length" && (
          <div className="side-bar_contents_info top-k">
            <h1>Response Length</h1>
            <br />
            <p>
              Your preference will be incorporated into the prompt provided to
              the LLM
            </p>
          </div>
        )}
        {type === "question_provide-sources" && (
          <div className="side-bar_contents_info top-k">
            <h1>Sources</h1>
            <br />
            <p>
              Your preference will be incorporated into the prompt provided to
              the LLM
            </p>
          </div>
        )}
        {type === "question_response-tone" && (
          <div className="side-bar_contents_info top-k">
            <h1>Tone of the response</h1>
            <br />
            <p>
              Your preference will be incorporated into the prompt provided to
              the LLM
            </p>
          </div>
        )}
        {type === "question_MMR" && (
          <div className="side-bar_contents_info top-k">
            <h1>Handling Repetitive Content</h1>
            <br />
            <p>
              For minimizing content repetition and enhancing content diversity
              in retrieval, we suggest implementing the MMR
              <b>(Maximal Marginal Relevance)</b> reranking method
            </p>
          </div>
        )}
        {type === "question_memory" && (
          <div className="side-bar_contents_info top-k">
            <h1>Memory</h1>
            <br />
            <p>This option will enable memory feature in the LLM</p>
          </div>
        )}
        {type === "question_chunk-size" && (
          <div className="side-bar_contents_info top-k">
            <h1>Chunking Strategy</h1>
            <br />
            <p>
              For shorter documents, consider using larger chunk sizes to fit
              entire documents in one chunk, thus avoiding potential context
              loss from chunking
            </p>
          </div>
        )}
        {type === "question_latency" && (
          <div className="side-bar_contents_info top-k">
            <h1>Latency</h1>
            <br />
            <p>
              For applications where delay is a critical factor, it's advised to
              avoid using a multiquery retriever. Although it's designed to
              enhance retrieval accuracy by rephrasing queries for better
              results, it involves multiple LLM calls and consequently increases
              latency
            </p>
          </div>
        )}
        {type === "question_references" && (
          <div className="side-bar_contents_info top-k">
            <h1>Cultural Sensitivity and Bias Management</h1>
            <br />
            <p>
              It's crucial to identify and manage cultural nuances, biases, or
              any discriminatory language in your documents. Your specific
              requirements, like avoiding hate speech, will be considered to
              ensure the application processes content responsibly and aligns
              with ethical standards
            </p>
          </div>
        )}
        {type === "additional-information" && (
          <div className="side-bar_contents_info top-k">
            <h1>Understanding the Additional Details for LLM Prompt</h1>
            <br />
            <br />
            <p>
              <span>Tone: </span> The tone of the LLM's responses is influenced
              by your answer to the question: "Do you have specific preferences
              for the tone or style of the responses?" Depending on whether you
              select a formal, informal, or persuasive tone, the LLM will adjust
              its language style accordingly to meet your specified preference.
            </p>
            <br />
            <p>
              <span>Response Length: </span> The length and detail of the LLM's
              responses are tailored based on your input to the question: "Would
              you prefer the LLM to provide detailed or concise answers?" If you
              opt for concise answers, the LLM aims to be brief and to the
              point. For detailed answers, expect more in-depth and elaborate
              responses.
            </p>
            <br />
            <p>
              <span>Return Sources: </span> This aspect is determined by your
              response to: "Do you want responses to reference or cite their
              sources for added reliability?" If you choose 'Yes', the LLM will
              include references or citations in its responses to enhance
              credibility and reliability.
            </p>
            <br />
            <p>
              <span>Recent Documents: </span> The focus on recent documents in
              the LLM's responses comes from your answer to: "Do you prefer to
              prioritize more recent documents in your responses?" Selecting
              'Yes' will prompt the LLM to give more weight to newer documents
              in its retrieval and response process, ensuring that the most
              current information is used.
            </p>
          </div>
        )}
        {type === "eval" && (
          <div className="side-bar_contents_info top-k">
            <h1>Evaluation</h1>
            <br />
            <p>Evaluation is based on the following metrics:</p>
            <br />
            <p>
              <span>Overall Accuracy: </span> The overall accuracy is the total
              of all the scores from the metrics below, adjusted to be out of
              10.
            </p>
            <p>
              <span>Feedback: </span> Overall feedback on how the response
              compares to the golden response.
            </p>
            <p>
              <span>Retrieval Accuracy (0-1): </span> Measures how well the
              retrieved context supports the information in the golden answer.
              It is calculated by breaking down the golden answer into
              independent facts and verifying whether each fact is supported by
              the retrieved context.
            </p>
            <h4 className="select-info">
              <span>0 - </span> If the retrieved context does not support any
              facts from the golden answer.
              <br />
              <span>0.5 - </span> If the retrieved context partially supports
              the facts from the golden answer. <br />
              <span>1 - </span> If the retrieved context fully supports all
              facts in the golden answer.
            </h4>
            <br />

            <p>
              <span>Correctness (0-1): </span> Correctness score measures how
              well the golden answer aligns with the generated answer. It is
              calculated by breaking down the golden answer into independent
              facts and verifying whether each fact is also contained in the
              generated answer.
            </p>
            <h4 className="select-info">
              <span>0 - </span> If the response contains none or minimal
              relevant information from the golden response.
              <br />
              <span>0.5 - </span> If the response includes partial information
              from the golden response. <br />
              <span>1 - </span> If the response perfectly aligns with the golden
              response.
            </h4>
            <br />
            <p>
              <span>Faithfulness (0,1): </span> Evaluates whether the generated
              answer truly derives from the provided context or if the bot is
              creating responses independently, without relying on the given
              information.
            </p>
            <br />
            <p>
              <span>Source eval (0,1): </span> Source eval measures whether the
              information attributed to a certain source is actually contained
              within that source. It is turned on if the LLM application
              settings require references to be provided with the answer.
            </p>
            <br />
          </div>
        )}
      </div>
    </div>
  );
};

export default SideBar;
